import { invokeHttp } from './api'

export const create = (inquiry) =>
  invokeHttp('/admin/patient/create', inquiry)

export const update = (patient) =>
  invokeHttp('/admin/patient/update', patient)

export const list = (filter) =>
  invokeHttp('/admin/patient/list', filter)

export const calendar = (id) =>
  invokeHttp('/admin/patient/calendar', { id })

export const get = (id) =>
  invokeHttp('/admin/patient/get', { id })

export const prepareupdate = (id) =>
  invokeHttp('/admin/patient/prepareupdate', { id })

export const setPhoto = (id, data, onProgress) =>
  invokeHttp(`/admin/patient/setphoto?id=${id}`, data, {
    onUploadProgress (progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      if (onProgress) {
        onProgress(percentCompleted)
      }
      return percentCompleted
    },
  })
